export const EXPORT_MANIFEST_DUMP = "export_backup.txt";

export const PING_TIMEOUT = 5 * 1000;
